import { Box, Header, Icon, Pressable } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { useNavigation } from 'navigation/hooks';
import { useAuthContext } from 'state/auth';
import { portalToFooter } from 'state/mobile-footer';
import { portalToReplaceHeader } from 'state/mobile-header-nav';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';
import { routes } from 'utils/routing';

import { MntCard } from './mnt';
import { WalmartOffer } from './walmart/walmart-offer';

export const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export const LoyaltyPartners = () => {
  const { formatMessage } = useIntl();
  const { navigate } = useNavigation();
  const { setAccountCallbackUrl } = useAuthContext();

  const AppHeader = portalToReplaceHeader(() => {
    return (
      <Box _ios={{ marginTop: '$12' }} _android={{ marginTop: '$3' }} marginTop={'$0'}>
        <Pressable
          onPress={() => {
            setAccountCallbackUrl(routes.base);
            navigate(routes.account);
          }}
          padding="$4"
        >
          <StyledBackIcon variant="back" />
        </Pressable>
        <Header alignSelf="center" variant="headerTwo" top="$4" position="absolute">
          {formatMessage({ id: 'partnerOffers' })}
        </Header>
      </Box>
    );
  });
  const AppFooter = portalToFooter(() => null);

  return (
    <LayoutContainer>
      <InnerLayout>
        <AppHeader />
        <WalmartOffer />
        <MntCard />
        <AppFooter />
      </InnerLayout>
    </LayoutContainer>
  );
};
